import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { FEATURE_DISABLED_CODE } from '@aiai/shared';

/** Is this an API 403 because the platform operator switched a workspace feature off? */
export function isFeatureDisabledError(err: unknown): boolean {
  return (
    axios.isAxiosError(err) &&
    (err.response?.data as { code?: unknown } | undefined)?.code === FEATURE_DISABLED_CODE
  );
}

/**
 * The ONE place a FEATURE_DISABLED refusal is handled: the operator switched a
 * feature off since the entitlements were last fetched, so refetch them (the
 * `['orgEntitlements', orgId]` key every gate reads, prefix-matched for any
 * org) and the UI flips to the locked state instead of keeping a dead control.
 */
function onApiError(err: unknown): void {
  if (isFeatureDisabledError(err)) {
    void queryClient.invalidateQueries({ queryKey: ['orgEntitlements'] });
  }
}

export const queryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache({ onError: onApiError }),
  mutationCache: new MutationCache({ onError: onApiError }),
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 10_000,
    },
  },
});
